import { SUPER_MINTER_ADDRESS, SUPER_MINTER_ABI } from '../../abi/super-minter.mjs';
import { mintTieredEditionArgs } from '../../helpers/mintTieredEditionArgs.mjs';

async function estimateGasMintTieredEdition(client, args) {
  const { account, value, bufferMultiplier = 1.2 } = args;
  const estimate = await client.estimateContractGas({
    address: SUPER_MINTER_ADDRESS,
    abi: SUPER_MINTER_ABI,
    functionName: "mintTo",
    args: mintTieredEditionArgs(args),
    account,
    value
  });
  const scaledBuffer = BigInt(Math.round(bufferMultiplier * 100));
  return estimate * scaledBuffer / 100n;
}

export { estimateGasMintTieredEdition };
